import { render, staticRenderFns } from "./courseList_new.vue?vue&type=template&id=0b70cc24&scoped=true"
import script from "./courseList_new.vue?vue&type=script&lang=js"
export * from "./courseList_new.vue?vue&type=script&lang=js"
import style0 from "./courseList_new.vue?vue&type=style&index=0&id=0b70cc24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b70cc24",
  null
  
)

export default component.exports